export default __webpack_public_path__ + "static/media/amazons3.c13efab4.svg";